<div class="panel-container">
  <header class="header">
    <img src="./assets/temporals/Logo_Akana_Azul.png" alt="">
  </header>
  <main class="main">
    <div class="panel">
      <div class="panel-text">
        <h2>Panel de gestion</h2>
      </div>
      <form [formGroup]="portalForm" method="POST" autocomplete="off">
        <label for="name">
          Usuario
          <input type="text" formControlName="user" name="name" id="portalName">
        </label> <br>
        <label for="pass">
          Contraseña
          <input type="password" formControlName="pass" name="pass" id="portalPass">
        </label>

        <button type="submit" id="portalButton" (click)="sendForm()">Entrar</button>
        <p style="color: red;" *ngIf="message">{{message}}</p>
      </form>
    </div>
  </main>
  <footer class="footer">Portal de Administración</footer>
</div>
